import { compose } from 'recompose';
import withE2EProp from '../../withE2EProp';
import centeredQuestion from '../hoc/centeredQuestion';
import RespondentInfoQuestion from './RespondentInfoQuestion';

export default compose(
  withE2EProp('respondent-email'),
  centeredQuestion,
)(RespondentInfoQuestion);
